import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { updateReport } from "../store/reducers/report";
import { color, flexCenterDir, levelBtn, overflowY } from "../styles/theme";
import DetailBtn from "./detail/Button";

interface ITable {
	title: string;
	viewDetailHandler?: any;
	data?: any[];
	getSelector?: any;
}

const Table = ({ title, viewDetailHandler, data, getSelector }: ITable) => {
	const dispatch = useDispatch();

	console.log("title", title);

	return (
		<TableSection>
			{/* {title === "BountyList" && (
				<TableHeader>
					<span></span>
					<span>Project</span>
					<span>Reward</span>
					<span>테스트 참여자</span>
					<span>Bounty Area</span>
					<span></span>
				</TableHeader>
			)}

			{title === "Submissions" && (
				<TableHeader>
					<span>Title</span>
					<span>Level</span>
					<span>Bounty Area</span>
					<span>Status</span>
					<span></span>
				</TableHeader>
			)} */}

			<TableBody>
				{title === "BountyList" &&
					data?.reverse()?.map((el, idx) => (
						<TableEl>
							<div className="low">
								<img src={el.image} className="imgBox" alt="img" />
								<div className="column">
									<div className="low">
										<span className="title">{el.projectName}</span>
										<span className="label">SmartContract</span>
									</div>
									<span className="reward">
										$ {el.bounty} - {el.reward}
									</span>
								</div>
							</div>
							<DetailBtn onClick={() => getSelector(idx)}>View Detail</DetailBtn>
						</TableEl>
					))}

				{title === "Submissions" &&
					[
						{
							title: "solidity reentrancy attack suspe...",
							level: "Critical",
							color: color.red,
							area: "SmartContract",
							status: "Pending",
						},
						{
							title: "Bump bugreport from 0.4.1 to...",
							level: "Low",
							color: color.violet,
							area: "SmartContract",
							status: "Confirm",
						},
						{
							title: "Error: HapSolo has two seperate set...",
							level: "High",
							color: color.yellow,
							area: "SmartContract",
							status: "Pending",
						},
					].map((el) => (
						<TableItem>
							<div className="headers">
								<div className="labelBox">
									<LevelLabel color={el.color}>{el.level}</LevelLabel>
									<LevelLabel color={"#777777"}>{el.area}</LevelLabel>
									<LevelLabel color={"#0a5680"}>{el.status}</LevelLabel>
								</div>
								<span className="submissionTitle">{el.title}</span>
							</div>
							<DetailBtn onClick={() => dispatch(updateReport(true))}>View Detail</DetailBtn>
						</TableItem>
					))}
			</TableBody>
		</TableSection>
	);
};

const TableSection = styled.div`
	${flexCenterDir}
	${overflowY}

  justify-content: flex-start;
	width: 70%;
	z-index: 2;
`;

// const TableHeader = styled.div`
// 	display: flex;
// 	justify-content: space-around;
// 	border-bottom: 3px solid ${color.darkGreen};
// 	margin-bottom: 39px;
// 	padding: 0 85px;
// 	padding-bottom: 28px;

// 	span {
// 		font-size: 22px;
// 		font-weight: bold;
// 		line-height: 33px;
// 	}
// `;

const TableBody = styled.div`
	${overflowY}

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
`;

const TableEl = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 98%;
	min-height: 6.5rem;
	height: 12rem;
	padding: 0 1.5rem;
	box-sizing: border-box;
	background: #262626;
	border-radius: 0.4rem;
	margin-bottom: 37px;

	.imgBox {
		width: 4rem;
		height: 4rem;
		min-width: 4rem;
		min-height: 4rem;
		background: #d9d9d9;
		margin-right: 3rem;
	}

	.low {
		display: flex;
		align-items: center;
	}

	.column {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.title {
		font-size: 1.6rem;
		margin-right: 0.5rem;
	}

	.label {
		font-size: 1rem;
		padding: 0 0.5rem;
		box-sizing: border-box;
		border-radius: 3px;
		background: gray;
		transform: scale(0.7);
	}

	span {
		font-size: 1rem;
		line-height: 33px;
	}
`;

const TableItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 98%;
	min-height: 6.5rem;
	height: 8rem;
	padding: 0 1rem;
	box-sizing: border-box;
	background: #262626;
	border-radius: 3px;
	margin-bottom: 37px;

	.headers {
		display: flex;
		flex-direction: column;
	}

	.submissionTitle {
		font-size: 2rem;
		margin-left: 0.7rem;
	}

	.labelBox {
		display: flex;
		justify-content: flex-start;
		margin-bottom: 0.5rem;
	}

	.imgBox {
		width: 4rem;
		height: 4rem;
		min-width: 4rem;
		min-height: 4rem;
		background: #d9d9d9;
		border-radius: 42.5008px;
	}

	span {
		font-size: 22px;
		line-height: 33px;
	}
`;

interface ILevelLabel {
	color: string;
}

const LevelLabel = styled.div<ILevelLabel>`
	${levelBtn}

	background: ${(props) => props.color};
	transform: scale(0.7);
	width: fit-content;
	height: fit-content;
	padding: 0.5rem;
	box-sizing: border-box;
	margin-right: -1.5rem;
`;

export default Table;
